import api from 'shared/api'
import { setSearchQueryParam, formatOrderBy } from 'shared/helpers'

const basePageSize = 20

// Get License Users list
export const fetchLicenseUsers = (
  companyId,
  page = 0,
  query,
  queryType,
  orderBy,
  pageSize = basePageSize
) => {
  const queryUrl = setSearchQueryParam(query, queryType)
  const orderUrl = orderBy
    ? `&order_by=${orderBy.map(orderType => `${orderType.desc ? '-' : ''}${orderType.id}`)}`
    : ''
  const url = `/api/v1/license-users/?company=${companyId}&limit=${pageSize}&offset=${
    page ? page * pageSize : 0
  }${orderUrl}${queryUrl}`
  return api.get(url)
}

// create License User
export const addLicenseUser = (companyID, data) =>
  api.post(`/api/v1/license-users/?company=${companyID}`, data)

// Get License User licenses list
export const fetchLicenseUserLicenses = (companyId, userID, page = 0, orderBy) => {
  const orderUrl = formatOrderBy(orderBy)
  const url = `/api/v1/licenses/?company=${companyId}&limit=20&offset=${page *
    basePageSize}${orderUrl}&license_users__id=${userID}&bundle_license__isnull=1`
  return api.get(url)
}

// delete License User
export const deleteLicenseUser = (userID, companyID) =>
  api.delete(`/api/v1/license-users/${userID}/?company=${companyID}`)

// Get License User Groups list
export const fetchUserGroups = (
  companyId,
  page = 0,
  query,
  queryType,
  orderBy,
  pageSize = basePageSize,
  additionalParams = {}
) => {
  const queryUrl = setSearchQueryParam(query, queryType)
  const orderUrl = orderBy
    ? `&order_by=${orderBy.map(orderType => `${orderType.desc ? '-' : ''}${orderType.id}`)}`
    : ''

  // Build additional params string
  let additionalParamsUrl = ''
  if (additionalParams && Object.keys(additionalParams).length > 0) {
    Object.entries(additionalParams).forEach(([key, value]) => {
      if (value) {
        additionalParamsUrl += `&${value}`
      }
    })
  }

  const url = `/api/v1/license-user-groups/?company=${companyId}&limit=${pageSize}&offset=${page *
    pageSize}${orderUrl}${queryUrl}${additionalParamsUrl}`
  return api.get(url)
}

// Get License User Group details
export const getUserGroup = (companyId, groupID) =>
  api.get(`/api/v1/license-user-groups/${groupID}/?company=${companyId}`)

// create License User Group
export const addUserGroup = (companyID, data) =>
  api.post(`/api/v1/license-user-groups/?company=${companyID}`, data)

// update License User Group
export const updateUserGroup = (companyID, groupID, data) =>
  api.patch(`/api/v1/license-user-groups/${groupID}/?company=${companyID}`, data)

// delete License User Group
export const deleteUserGroup = (companyID, groupID) =>
  api.delete(`/api/v1/license-user-groups/${groupID}/?company=${companyID}`)

// Get License User Group members
export const getUserGroupMembers = (companyID, groupID, page = 0) => {
  const url = `/api/v1/license-user-groups/${groupID}/members/?company=${companyID}&limit=20&offset=${page *
    basePageSize}`
  return api.get(url)
}

// Get License User Groups for a specific user
export const getLicenseUserGroups = (companyID, userID, page = 0, pageSize = basePageSize) => {
  const url = `/api/v1/license-users/${userID}/groups?company=${companyID}&limit=${pageSize}&offset=${page *
    pageSize}`
  return api.get(url)
}

// Add License User to License User Group
export const addUserToGroup = (companyID, userID, data) =>
  api.post(`/api/v1/license-users/${userID}/add_to_group?company=${companyID}`, data)

// Remove License User from License User Group
export const removeUserFromGroup = (companyID, userID, data) =>
  api.post(`/api/v1/license-users/${userID}/remove_from_group?company=${companyID}`, data)

// Assign User Group to License
export const assignUserGroupToLicense = (companyID, licenseID, data) =>
  api.post(`/api/v1/licenses/${licenseID}/assign_user_group?company=${companyID}`, data)

// Get managers of user group
export const getUserGroupManagers = (companyID, groupID) =>
  api.get(`/api/v1/license-user-groups/${groupID}/managers/?company=${companyID}`)

// Add manager to user group
export const addUserGroupManager = (companyID, groupID, data) =>
  api.post(`/api/v1/license-user-groups/${groupID}/add_manager/?company=${companyID}`, data)

// Remove manager from user group
export const removeUserGroupManager = (companyID, groupID, data) =>
  api.post(`/api/v1/license-user-groups/${groupID}/remove_manager/?company=${companyID}`, data)

// get User Group licenses
export const getUserGroupLicenses = (companyId, groupID, page = 0, orderBy) => {
  const orderUrl = formatOrderBy(orderBy)
  const url = `/api/v1/licenses/?company=${companyId}&limit=20&offset=${page *
    basePageSize}${orderUrl}&license_user_group=${groupID}&bundle_license__isnull=1`
  return api.get(url)
}
